import React from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';

import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import Button from '../Button';

const SearchFilterDropdownContainer = (props) => {
  const {
    children, toggleIsOpen, translationKey, title, setFocusTrap,
  } = props;

  return (
    <FocusTrap
      active
      focusTrapOptions={{
        allowOutsideClick: true,
        clickOutsideDeactivates: true,
        onDeactivate: setFocusTrap,
      }}
    >
      <div className="SearchFilter__Dropdown">
        <div className="SearchFilter__Dropdown__header">
          <TranslationProvider translationKey={translationKey}>
            <div className="SearchFilter__Dropdown__title">{title}</div>
          </TranslationProvider>
          <div className="SearchFilter__Dropdown__close-button">
            <Button
              aria-label={getTranslation({
                translationKey: 'close',
                fallback: 'Close',
              })}
              data-test-id="search-filter-close"
              onClick={() => toggleIsOpen(false)}
              variant="close"
            />
          </div>
        </div>
        <div className="SearchFilter__Dropdown__divider" />
        {children}
      </div>
    </FocusTrap>
  );
};

SearchFilterDropdownContainer.propTypes = {
  title: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
  setFocusTrap: PropTypes.func.isRequired,
};

SearchFilterDropdownContainer.displayName = 'SearchFilterDropdownContainer';
export default SearchFilterDropdownContainer;
